






import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import IListTile from '@/types/components/IListTile.interface'
import Vue from 'vue'
import { mapGetters } from 'vuex'
export interface Plugin {
    line1: string
    line2: string
    icon?: string
    color: string
    callback: Function
    disabledPopup?: boolean
    hidden?: boolean
    img?: string
}
export default Vue.extend({
    data() {
        return {
            toolbar: {
                title: 'Plugins',
                left: [
                    {
                        title: 'Back',
                        icon: 'mdi-chevron-left',
                        back: '/home',
                        tooltip: 'Back'
                    }
                ],
                right: []
            }
        }
    },
    computed: {
        ...mapGetters(['isApp', 'qboHasAccount', 'tenant', 'xeroHasAccount']),
        items(): Plugin[] {
            const items = [
                // {
                //     id: 1,
                //     line1: `Short Links ${
                //         this.isApp ? '' : '<span class="new-badge">beta</span></div>'
                //     }`,
                //     line2: 'Shorten URLs and view your link analytics',
                //     icon: 'bi-input-cursor-text',
                //     color: 'primary',
                //     callback: () => this.$router.push('/short-links'),
                //     hidden: this.tenant.account_status !== 'active'
                // },
                {
                    id: 2,
                    line1: 'Media',
                    line2: 'View your uploaded and received files and images',
                    icon: 'mdi-file-image-outline',
                    color: 'primary',
                    callback: () => this.$router.push('/media')
                },
                {
                    id: 3,
                    line1: 'Pay by Text',
                    line2: 'Create and text invoices using your Sphere Merchant Account',
                    icon: 'mdi-link-variant',
                    color: 'primary',
                    callback: () => this.$router.push('/sphere'),
                    disabledPopup: !this.$store.getters.userHasPermission(3),
                    hidden: this.isApp
                },
                {
                    id: 4,
                    line1: 'QuickBooks Online',
                    line2: `Connect and sync your QuickBooks Online customers`,
                    icon: 'mdi-link-variant',
                    color: 'primary',
                    callback: () => this.$router.push('/qbo'),
                    disabledPopup: !this.$store.getters.userHasPermission(2),
                    hidden: this.qboHidden
                },
                {
                    id: 5,
                    line1: 'Xero',
                    line2: `Connect and sync your Xero contacts`,
                    icon: 'mdi-link-variant',
                    color: 'primary',
                    callback: () => this.$router.push('/xero'),
                    disabledPopup: !this.$store.getters.userHasPermission(2),
                    hidden: this.xeroHidden
                },
                {
                    id: 6,
                    line1: 'Carrier Registration',
                    line2: 'Register your business with carriers to prevent blocked messages',
                    icon: 'mdi-card-account-phone',
                    color: 'primary',
                    callback: () => this.$router.push('/brand-info'),
                    disabledPopup: !this.$store.getters.userHasPermission(3),
                    hidden: this.isApp
                },
                {
                    id: 7,
                    line1: 'Custom Fields',
                    line2: 'Create and edit custom fields for your contacts',
                    icon: 'mdi-format-annotation-plus',
                    color: 'primary',
                    callback: () => this.$router.push('/custom-fields'),
                    disabledPopup: !this.$store.getters.userHasPermission(2)
                },
                {
                    id: 8,
                    line1: 'Merge Contacts',
                    line2: 'Merge contacts with duplicate numbers',
                    icon: 'mdi-account-switch',
                    color: 'primary',
                    callback: () => this.$router.push('/settings/merge-contacts'),
                    hidden:
                        this.tenant.data_provider === 'QBO' ||
                        this.tenant.data_provider === 'XERO'
                },
                {
                    id: 9,
                    line1: 'Zapier',
                    line2: 'Integrate MessageDesk with other apps via Zapier',
                    img: 'zapier',
                    color: 'primary',
                    callback: () =>
                        window.open(
                            'https://learn.messagedesk.com/en/articles/5375208-how-to-connect-zapier-to-messagedesk',
                            this.isApp ? '_system' : '_blank'
                        ),
                    disabledPopup: !this.$store.getters.userHasPermission(3),
                    hidden: this.isApp || this.tenant.account_status !== 'active'
                }
            ]
            return items.filter((x: Plugin) => x.hidden !== true)
        },
        qboHidden(): boolean {
            //  if the tenant data_provider is null, show the qbo item
            if (!this.tenant.data_provider) return false

            //  If the tenant data_provider is QBO, show the qbo item
            if (this.qboHasAccount) return false

            //  Else, hide the qbo item
            return true
        },
        xeroHidden(): boolean {
            //  if the tenant data_provider is null, show the xero item
            if (!this.tenant.data_provider) return false

            //  If the tenant data_provider is xero, show the xero item
            if (this.xeroHasAccount) return false

            //  Else, hide the xero item
            return true
        }
    },
    methods: {
        pluginIcon(extra: Plugin): IListIcon {
            //  Our icon comes from the plugin
            const icon = extra.icon

            //  Grab the image from the plugin as well
            const img = extra.img

            //  Create our list icon
            const listIcon: IListIcon = {
                type: img ? IListIconType.img : IListIconType.icon,
                content: img ? img : icon,
                color: 'primary'
            }

            //  Return our list icon
            return listIcon
        },
        pluginTile(): IListTile {
            return {
                line1: (extra: Plugin): string => extra.line1,
                line2: (extra: Plugin): string => extra.line2,
                leftIcon: (extra: Plugin): string => this.pluginIcon(extra),
                color: (extra: Plugin): string => extra.color,
                callback: (extra: Plugin): void => extra.callback()
            }
        }
    }
})
